var map = {
	"./_0000_btn_icon_castle.png": "9976",
	"./_0000_btn_icon_meat.png": "ec96",
	"./_0001_btn_icon_bag.png": "2dd2",
	"./_0001_btn_icon_card.png": "6314",
	"./_0002_btn_icon_passive.png": "8b5b",
	"./_0002_btn_icon_scroll.png": "598c",
	"./_0003_btn_icon_anvil.png": "ebd5",
	"./_0003_btn_icon_door.png": "0efc",
	"./_0004_btn_icon_ring.png": "db83",
	"./_0004_btn_icon_sword.png": "884a",
	"./_0005_btn_icon_fight.png": "8a21a",
	"./_0005_btn_icon_rune.png": "be07",
	"./_0006_btn_icon_light.png": "66ed",
	"./_0006_btn_icon_posion.png": "83ee",
	"./_0007_btn_icon_potion.png": "3779",
	"./_0007_btn_icon_speed.png": "151c",
	"./_0008_btn_icon_defense.png": "bcb5",
	"./_0009_btn_icon_damage.png": "5a26",
	"./glove-icon.png": "6b56",
	"./icon-ensign.png": "a8b7c",
	"./icon-lantern.png": "20c0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c327";